import { Card, CardContent, FormControl, MenuItem, Select, TextField } from '@mui/material';
import { SCUIButton } from '../../../../../../../atomic/atoms';
import { OrderQuery } from '../../../../../../../services/query';
import { useEffect, useState } from 'react';
import { OrderCommand } from '../../../../../../../services/command';
import { fetchOrderDetails } from '../../../../../../../stores/redux/actions';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import Swal from 'sweetalert2';
import { OIC_CO } from '../orderInformationCard.classes';

function CancelOrder({ handleCloseModal }: any) {
    const { t } = useTranslation();
    const { data }: any = useSelector((state: any) => state.orderDetails);
    const [selectedReason, setSelectedReason] = useState<any>(t('general.chooseStatus'));
    const dispatch = useDispatch();
    const [showTextBox, setShowTextBox] = useState(false);
    const [textBoxValue, setTextBoxValue] = useState('');
    const [cancelReasons, setCancelReasons] = useState<any>(null);
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState(false);

    useEffect(() => {
        setIsLoading(true);
        OrderQuery.GetOrderCancelReason()
            .then((res) => {
                setCancelReasons(res);
            })
            .catch(() => {
                setError(true);
            })
            .finally(() => {
                setIsLoading(false);
            });
    }, []);

    if (isLoading) {
        return <div className={OIC_CO.loading}>Yükleniyor...</div>;
    }
    if (error) {
        return <div className={OIC_CO.error}>Hata oluştu</div>;
    }

    const handleSelectChange = (event: any) => {
        if (event.target.value !== 'CancelReason_Backend_Other') setTextBoxValue('');
        event.stopPropagation();
        setSelectedReason(event.target.value);
        setShowTextBox(event.target.value === 'CancelReason_Backend_Other' || event.target.value === 'Diğer');
    };

    const cancelledStatus = 6;

    const handleSubmitForm = async () => {
        if (selectedReason == 'Statü Seç' || selectedReason == 'ChooseStatus') {
            Swal.fire('Lütfen bir iptal nedeni seçiniz', ' ', 'warning');
            return;
        }
        if ((selectedReason == 'Diğer' || selectedReason == 'CancelReason_Backend_Other') && !textBoxValue) {
            Swal.fire('İptal etme nedeni kutucuğunu doldurunuz', ' ', 'warning');
            return;
        }

        Swal.fire({
            title: t('refund.processing'),
            html: 'İptal işlemi gerçekleştiriliyor, lütfen bekleyin...',
            allowOutsideClick: false,
            allowEscapeKey: false,
            allowEnterKey: false,
            didOpen: () => {
                Swal.showLoading();
            },
        });

        try {
            const result: any = await OrderCommand.CancelOrderStatus({
                orderId: data.orderId,
                customerId: data.customerId,
                operatorId: JSON.parse(localStorage.getItem('checkOperator') || '{}').operatorId,
                oldStatus: data.orderStatusId,
                newStatus: cancelledStatus,
                cancelReason: selectedReason,
                description: textBoxValue,
            });

            if (result?.result == 4 || result?.isSucceed == true) {
                dispatch(fetchOrderDetails({ orderId: data.orderId }));
                await Swal.fire({
                    title: t('general.success'),
                    text: 'Statü başarılı bir şekilde güncellenmiştir.',
                    icon: 'success',
                    showConfirmButton: false,
                    timer: 3000,
                });
                setTimeout(() => {
                    window.location.reload();
                }, 3000);
            } else {
                Swal.fire('İptal işlemi başarısız', ' ', 'error');
                handleCloseModal();
            }
        } catch (err: any) {
            console.error('Bir hata oluştu:', err);
            Swal.fire('İptal işlemi başarısız', ' ', 'error');
            handleCloseModal();
        } finally {
            Swal.close();
        }
    };

    return (
        cancelReasons && (
            <Card className={OIC_CO.rootCard} variant="outlined" style={{ minWidth: '300px', height: 'auto' }}>
                <CardContent className={OIC_CO.content}>
                    <form
                        className={OIC_CO.form}
                        onSubmit={(event) => {
                            event.preventDefault();
                            handleSubmitForm();
                        }}
                    >
                        <div className={OIC_CO.formColumn} style={{ display: 'flex', flexDirection: 'column' }}>
                            <FormControl
                                className={OIC_CO.reasonControl}
                                fullWidth
                                style={{ marginBottom: '1rem', maxWidth: '300px' }}
                            >
                                <p className={OIC_CO.reasonLabel}>{t('orderDetail.cancelReason')}</p>
                                <Select
                                    className={OIC_CO.inputSelectReason}
                                    value={selectedReason}
                                    onChange={handleSelectChange}
                                    displayEmpty
                                    inputProps={{ 'aria-label': 'Without label' }}
                                >
                                    <MenuItem value={selectedReason} disabled>
                                        {t('general.chooseStatus')}
                                    </MenuItem>
                                    {cancelReasons.data.map(
                                        (status: any, index: any) =>
                                            status.descriptionKey != 'ChooseStatus' && (
                                                <MenuItem key={index} value={status.descriptionKey}>
                                                    {status.descriptionKey}
                                                </MenuItem>
                                            )
                                    )}
                                </Select>
                                {showTextBox && (
                                    <TextField
                                        className={OIC_CO.inputTextOtherReason}
                                        fullWidth
                                        style={{
                                            marginBottom: '1rem',
                                            maxWidth: '300px',
                                            marginTop: '1rem',
                                        }}
                                        value={textBoxValue}
                                        onChange={(e) => setTextBoxValue(e.target.value)}
                                        label="İptal sebebi giriniz"
                                        variant="outlined"
                                    />
                                )}
                            </FormControl>
                            <SCUIButton
                                className={OIC_CO.inputButtonSubmit}
                                style={{ maxWidth: '300px' }}
                                type={'primary'}
                                sizeType={'fixed'}
                                size={'s'}
                                text={'Kaydet'}
                            ></SCUIButton>
                        </div>
                    </form>
                </CardContent>
            </Card>
        )
    );
}

export default CancelOrder;
